module.exports = __webpack_public_path__ + "static/img/postBoxBanner.30245b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/postBoxBanner.png
// module id = T5Pp
// module chunks = 2